import React from 'react';
import { Node, parseMessage } from './message-format';

const render = (nodes: Node[], tone: 'light' | 'dark'): React.ReactNode[] =>
  nodes.map((node, i) => {
    switch (node.kind) {
      case 'text':
        return <React.Fragment key={i}>{node.text}</React.Fragment>;
      case 'link':
        return (
          <a
            key={i}
            href={node.href}
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 break-all"
          >
            {node.text}
          </a>
        );
      case 'code':
        return (
          <code key={i} className={`px-1 rounded font-mono text-[0.85em] ${tone === 'dark' ? 'bg-white/20' : 'bg-gray-100'}`}>
            {node.text}
          </code>
        );
      case 'block':
        return (
          <pre key={i} className={`my-1 p-2 rounded font-mono text-xs whitespace-pre-wrap ${tone === 'dark' ? 'bg-white/20' : 'bg-gray-100'}`}>
            {node.text}
          </pre>
        );
      case 'bold':
        return <strong key={i}>{render(node.children, tone)}</strong>;
      case 'italic':
        return <em key={i}>{render(node.children, tone)}</em>;
      case 'strike':
        return <s key={i}>{render(node.children, tone)}</s>;
    }
  });

/**
 * Message text as the recipient sees it: WhatsApp formatting applied, line
 * breaks kept, links clickable. `markup={false}` for SMS and email, which
 * have no formatting of their own.
 */
const MessageText: React.FC<{
  text: string;
  markup?: boolean;
  /** `dark` on a coloured (outgoing) bubble, so code shading stays visible. */
  tone?: 'light' | 'dark';
  className?: string;
}> = ({ text, markup = true, tone = 'light', className = 'text-sm' }) => (
  <p className={`${className} whitespace-pre-wrap break-words`}>{render(parseMessage(text, { markup }), tone)}</p>
);

export default MessageText;
